
























































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import InGameNameRegistration from '@/modules/tournament/components/InGameNameRegistration'
import ReadAndAccept from '@/modules/tournament/components/ReadAndAccept'
import EnterInvitationCode from '@/modules/tournament/components/EnterInvitationCode'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import layoutStore from '@/modules/shared/layout.store'
import { TournamentAPI } from '@/api/tournament'
import ServerError from '@/utils/server_error'
import TeamJoinDetailReview from '../TournamentActionDialog/TeamJoinDetailReview'
import { TokenAcceptPayload } from '../EnterInvitationCode/EnterInvitationCode.vue'

@Component({
  components: {
    InGameNameRegistration,
    ReadAndAccept,
    EnterInvitationCode,
    TeamJoinDetailReview
  }
})
export default class TournamentTeamTokenDialog extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  layoutModule = getModule(layoutStore, this.$store)
  step: number = 1
  steps: number[] = Array.from(new Array(5), (_, index) => index + 1)
  teamToken: string = ''
  selectedTokenTeam: TokenAcceptPayload | null = null

  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get isVisible() {
    return this.layoutModule.isTeamTokenDialogVisible
  }

  get defaultTeamToken() {
    return this.layoutModule.defaultTeamToken
  }

  @Ref('gameAccountRegistration')
  readonly gameAccountRegistration!: InGameNameRegistration

  @Ref('readAndAccept')
  readonly readAndAccept!: ReadAndAccept

  @Ref('enterInvitationCode')
  readonly enterInvitationCode!: EnterInvitationCode

  @Watch('isVisible')
  async onVisibleChanged(visible: boolean) {
    if (visible) {
      this.reset()

      if (this.defaultTeamToken !== '') {
        this.$nextTick(() => {
          this.enterInvitationCode.submitTeamToken(this.defaultTeamToken)
        })
      }
    } else {
      setTimeout(this.reset, 200)
    }
  }

  show() {
    this.layoutModule.setTeamTokenDialogVisible(true)
  }

  close() {
    this.layoutModule.setTeamTokenDialogVisible(false)
  }

  reset() {
    this.step = 1

    if (this.gameAccountRegistration) {
      this.gameAccountRegistration.reset()
    }

    if (this.readAndAccept) {
      this.readAndAccept.reset()
    }

    if (this.enterInvitationCode) {
      this.enterInvitationCode.reset()
    }

    this.selectedTokenTeam = null
    this.teamToken = ''
  }

  onAcceptTeamToken(payload: TokenAcceptPayload) {
    // store the team token and show T&C before actually accept the token
    this.teamToken = payload.token
    this.selectedTokenTeam = payload
    this.step = 2
  }

  onReadAndAccept() {
    this.step = 3
  }

  onIGNConfirmed() {
    this.step = 4
  }

  async joinTournamentTeamByTeamToken() {
    this.step = 5

    try {
      await TournamentAPI.joinTournamentTeamByTeamToken(this.teamToken)
      await this.$router.push({
        name: 'TournamentDetailsOverview',
        params: {
          tournamentId: this.tournamentModule.selectedTournament!.tournamentId
        }
      })

      this.$toast.success(
        this.$t(
          'TournamentTeamTokenDialog.YouHaveJoinedTheTournamentSuccessfully'
        )
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(
          this.$t('TournamentTeamTokenDialog.SystemErrorMessage')
        )
        console.error(err)
      }
    } finally {
      this.close()
    }
  }
}
